import './App.css';

import Componets from './Componets/Componets';
function App() {

  return (
    <div className="App">
      <header className="App-header">
        <div style={{width: '100%', height: '100vh'}}>
          
          <Componets />
        </div>


      </header>
    </div>
  );
}

export default App;